import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialValues, SearchFormValues, searchSchema } from '../schema';
import { buildSoChiTietCongNoSearchPayload } from '../utils';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import { useToast } from '@/hooks/use-toast';
interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SearchFormValues) => void;
  searchFieldStates: BanHangRecord;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({
  open,
  onClose,
  onSearch,
  searchFieldStates
}) => {
  const { toast } = useToast();

  const handleSubmit = (data: SearchFormValues) => {
    if (!searchFieldStates.account) {
      toast({
        variant: 'destructive',

        description: 'Vui lòng chọn tài khoản.'
      });
      return;
    }

    if (!searchFieldStates.customer) {
      toast({
        variant: 'destructive',

        description: 'Vui lòng chọn khách hàng.'
      });
      return;
    }

    const combinedData = buildSoChiTietCongNoSearchPayload(
      data,
      searchFieldStates.account.uuid,
      searchFieldStates.customer.uuid
    );

    onSearch(combinedData);
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Sổ chi tiết công nợ theo khách hàng'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[950px] min-w-[950px] overflow-y-auto'>
            <BasicInfo
              searchFieldStates={{ account: searchFieldStates.account, setAccount: searchFieldStates.setAccount }}
            />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab searchFieldStates={searchFieldStates} />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
